<script setup lang="ts">
/** Named-view placeholder when the matched route has no right-rail context. */
</script>

<template>
  <span class="zw-context-empty" hidden />
</template>
